import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { BlacklistModel, CreateBlacklistModel, SourceModel } from 'Pages/coliseum'

export type BlacklistState = {
	blacklist: ResponseCatalog<BlacklistModel>
	requestParams: RequestParams
	source: SourceModel[]
}

export const BlacklistInitialState: BlacklistState = {
	blacklist: new ResponseCatalog<BlacklistModel>(),
	requestParams: new RequestParams(),
	source: [],
}

export namespace BlacklistNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
	}>
	export type SetAll = PayloadAction<ResponseCatalog<BlacklistModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type CreateOne = PayloadAction<CreateBlacklistModel>
	export type GetAllSource = PayloadAction
	export type SetAllSource = PayloadAction<SourceModel[]>
	export type MassloadAll = PayloadAction<{
		file: any
	}>
	export type ClearAllSource = PayloadAction
}

export const blacklistSlice = createSlice({
	name: 'blacklist',
	initialState: BlacklistInitialState,
	reducers: {
		getAll: (state, action: BlacklistNS.GetAll) => {},
		setAll: (state, action: BlacklistNS.SetAll) => {
			state.blacklist = action.payload
		},
		setRequestParams: (state, action: BlacklistNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.blacklist = new ResponseCatalog<BlacklistModel>()
			state.requestParams = new RequestParams()
		},
		createOne: (state, action: BlacklistNS.CreateOne) => {},
		getAllSource: (state, action: BlacklistNS.GetAllSource) => {},
		setAllSource: (state, action: BlacklistNS.SetAllSource) => {
			state.source = action.payload
		},
		clearAllSource: (state, action: BlacklistNS.ClearAllSource) => {
			state.source = []
		},
		massloadAll: (state, action: BlacklistNS.MassloadAll) => {},
	},
})
